import { IViewFactfindChecklist } from '@zeta-types';
import { create } from 'zustand';
import { IffCheckListStore } from './types';

export const useffCheckListStore = create<IffCheckListStore>((set) => ({
  ffCheckListDetails: {} as IViewFactfindChecklist,
  status: false,
  updateffCheckListDetails: (x: IViewFactfindChecklist, status: boolean) => set(() => ({ ffCheckListDetails: x, status: status })),
}));

export default useffCheckListStore;
